import type { JSX } from 'react';

import { Card } from '@change-corgi/design-system-legacy/components/content';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { useDashboardReskinExperiment } from '../../../../hooks/useDashboardReskinExperiment';

import { PetitionStats } from './components/PetitionStats';
import { PetitionStrengthScore } from './components/PetitionStrengthScore';
import { ReachedYourGoal } from './components/ReachedYourGoal';
import { usePetitionOverview } from './hooks/usePetitionOverview';
import { PetitionOverview as PetitionOverviewReskin } from './index_new';

export function PetitionOverview(): JSX.Element {
	const {
		data: { strengthTipsEnabled },
	} = usePetitionOverview();

	const {
		data: { isEnabled },
	} = useDashboardReskinExperiment();

	if (isEnabled) {
		return <PetitionOverviewReskin />;
	}

	return (
		<Box as="section" aria-labelledby="petition-overview-title" role="group" data-testid="petition-overview-control">
			<Card
				p="20px"
				backgroundColor="white"
				sx={{
					border: 'unset',
					display: 'grid',
					gridTemplateColumns: ['1fr', strengthTipsEnabled ? '2fr 1fr' : '1fr'],
					gridTemplateRows: 'auto 1fr',
					width: '100%',
					borderRadius: 'big',
				}}
			>
				<Box sx={{ position: 'relative' }}>
					<PetitionStats />
				</Box>
				{strengthTipsEnabled && <PetitionStrengthScore />}
				<Box sx={{ gridColumn: '1 / -1' }}>
					<ReachedYourGoal />
				</Box>
			</Card>
		</Box>
	);
}
